import { Dispatch } from "../../utility/common/storeHelper"
import store from "../store"
import { removeDraft, upsertDraft } from "./slice"

export const NEW_CLIENT_TEMP_ID = "new-client-temp-id"

export const setMessageInputDraft =
    (draft?: string, omniUserId?: string, isNewClient = false) =>
    async (dispatch: Dispatch) => {
        const currentClientOmniUserId = store.getState().dialogs.currentClientOmniUserId
        const targetOmniUserId = omniUserId ?? currentClientOmniUserId ?? (isNewClient ? NEW_CLIENT_TEMP_ID : undefined)

        if (targetOmniUserId) {
            if (draft) {
                dispatch(
                    upsertDraft({
                        id: targetOmniUserId,
                        content: draft
                    })
                )
            } else {
                dispatch(removeDraft(targetOmniUserId))
            }
        }
    }
